import images from "./fotos/importImages.js";

export const projects = [
  {
    title: "Letra Caixa",
    type: "letracaixa",
    image: images.letracaixa,
  },
  {
    title: "Backlight",
    type: "backlight",
    image: images.backlight,
  },
  {
    title: "Acrilico",
    type: "acrilico",
    image: images.acrilico,
  },
  {
    title: "Fachada",
    type: "fachada",
    image: images.fachada,
  },
  {
    title: "Led_Neon",
    type: "ledneon", // Manter em minúsculas
    image: images.ledneon, // Manter em minúsculas
  },
  {
    title: "Placas",
    type: "placas",
    image: images.placas,
  },
  {
    title: "Totem",
    type: "totem",
    image: images.totem,
  },
  {
    title: "Trofeus",
    type: "trofeus",
    image: images.trofeus,
  },
];

export const testimonials = [
  {
    quote:
    "Que show Lucas! Um profissional diferenciado, com conhecimento ímpar de se admirar. Parabéns pela visão e poder agregar para nosso mercado! Show, show, voe alto garoto!",
    image: "https://media.licdn.com/dms/image/C4D03AQEV6MNaJ5UtlA/profile-displayphoto-shrink_800_800/0/1517546387042?e=1698278400&v=beta&t=Hz8kYWuMB35w4xOTGB46VRev-sVs0a7wWAaMFbycVzE",
    name: "Gabriel Lalli",
    company: "JA CONSULTORIA E TREINAMENTOS",
  },
  {
    quote:
    "Fantástico! Já tocamos alguns projetos em conjunto e realmente a sua capacidade de projetar situações e analisar riscos com clareza em detalhes facilitam a entrega maximizando segurança / qualidade / e o grande diferencial levando ao cliente soluções. Muito obrigado sempre !",
    image: "https://media.licdn.com/dms/image/D4D35AQFMANdTDNoYPQ/profile-framedphoto-shrink_800_800/0/1692644105321?e=1693335600&v=beta&t=l8kmHeKdsaVihsnKY5kACJQsFlhkir6GI6_XGCzfMG8",
    name: "Antonio Bueno",
    company: "Técnico comercial",
  },
];

export const skills = [
  "Corte Router",
  "Corte a Laser",
  "Soldas em 45º",
  "Instaladores com NR-35 e NR-18",
  "Emissão de Contrato de Prestação de Serviço",
  "Layouts em 3D",
];



// WEBPACK FOOTER //
// ./src/data.js